import Img from 'gatsby-image';
import { chunk, first, sum } from 'lodash';
import React from 'react';
import { Box } from 'rebass';

const Gallery = props => {
  const validImages = (props.images || []).filter(
    item => item.image && item.image.childImageSharp
  );
  const half = Math.ceil(validImages.length / 2);
  const firstHalf = validImages.slice(0, half);
  const secondHalf = validImages.slice(-half);

  return (
    <div className='gallery'>
      <div id='top-row'>
        {
          firstHalf.map((item, index) =>
            <img key={item.id || index} className='gallery-image' src={item.image.childImageSharp.fluid.originalImg} alt="" />)
        }
      </div>
      <div id='bottom-row'>
        {
          secondHalf.map((item, index) =>
            <img key={item.id || index} className='gallery-image' src={item.image.childImageSharp.fluid.originalImg} alt="" />)
        }
      </div>
    </div>
  );
};

export default Gallery;
